<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/haYSch/tc-custom/9781439676271.jpg?1680490316795" alt="This image is the cover for the book Super Cities! Atlanta, Super Cities"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Super Cities! Atlanta, Super Cities
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Sometimes the coolest places are right outside your front door. Learning about Atlanta’s interesting and unique culture has never been so super fun!</strong></p><br/><p>Did you know that Dr. Martin Luther King, Jr. was born in Atlanta? Or that Inman Park, dating back to 1890, is Atlanta’s oldest neighborhood? Did you know that Stone Mountain is actually a monadnock? From the Olympic games to the World of Coca-Cola, <em>Super Cities!: Atlanta</em> covers it all and is sure to engage any reader with fun facts about the history, culture, and people who make this city great. Explore Little Five Points, and join in the fun at Centennial Olympic Park, all right here. Take a peek inside to learn more about the impressive, unusual, super history of Atlanta!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Bailey
      </h2>
      
      <p class="authorDescription body article">Diane Bailey has been writing and editing for about 30 years. She started in consumer journalism, and then moved into writing for children once her own kids were old enough to get into trouble without her assistance. Now, she's written almost 100 books for kids and teens, on everything from sports to science, but her favorite topics are history and the people who made it. Recently she's published children's biographies on Susan La Flesche Picotte, the country's first Native American to earn a medical degree; Fred Rogers, the beloved host of the children's TV show Mister Rogers' Neighborhood; Ida B. Wells, an activist for African American rights; and Gandhi, the famous activist from India. Diane has two grown sons and lives in Lawrence, Kansas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Children’s Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?531b079e